import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_enemy_type_proto from './dcei_wildsky_enemy_type_proto';
import * as dcei_wildsky_card_proto from './dcei_wildsky_card_proto';
export class LoadoutConfig {
  get descriptor() {
    return LoadoutConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasGameMode = false;
    this._gameMode = null;
    this._hasMaxHeroCard = false;
    this._maxHeroCard = null;
    this._hasMaxSpellCard = false;
    this._maxSpellCard = null;
    this._hasMaxTowerCard = false;
    this._maxTowerCard = null;
    this._affinityTowers = [];
    this._affinityHeros = [];
    this._affinitySpells = [];
    this._hasCardLevelCap = false;
    this._cardLevelCap = null;
  }
  isEmpty() {
    if (this._hasGameMode) return false;
    if (this._hasMaxHeroCard) return false;
    if (this._hasMaxSpellCard) return false;
    if (this._hasMaxTowerCard) return false;
    if (this._affinityTowers.length > 0) return false;
    if (this._affinityHeros.length > 0) return false;
    if (this._affinitySpells.length > 0) return false;
    if (this._hasCardLevelCap) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof LoadoutConfig) {
      return value;
    }
    return LoadoutConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new LoadoutConfig();
    if (json.gameMode != null) {
      result._hasGameMode = true;
      result._gameMode = JsonToString.fromJson(json.gameMode);
    }
    if (json.maxHeroCard != null) {
      result._hasMaxHeroCard = true;
      result._maxHeroCard = JsonToInt32.fromJson(json.maxHeroCard);
    }
    if (json.maxSpellCard != null) {
      result._hasMaxSpellCard = true;
      result._maxSpellCard = JsonToInt32.fromJson(json.maxSpellCard);
    }
    if (json.maxTowerCard != null) {
      result._hasMaxTowerCard = true;
      result._maxTowerCard = JsonToInt32.fromJson(json.maxTowerCard);
    }
    result._affinityTowers = JsonToList(json.affinityTowers, dcei_wildsky_card_proto.CardDefinition.Affinity);
    result._affinityHeros = JsonToList(json.affinityHeros, dcei_wildsky_card_proto.CardDefinition.Affinity);
    result._affinitySpells = JsonToList(json.affinitySpells, dcei_wildsky_card_proto.CardDefinition.Affinity);
    if (json.cardLevelCap != null) {
      result._hasCardLevelCap = true;
      result._cardLevelCap = JsonToInt32.fromJson(json.cardLevelCap);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasGameMode) {
      result.gameMode = JsonToString.toJson(this._gameMode);
    }
    if (this._hasMaxHeroCard) {
      result.maxHeroCard = JsonToInt32.toJson(this._maxHeroCard);
    }
    if (this._hasMaxSpellCard) {
      result.maxSpellCard = JsonToInt32.toJson(this._maxSpellCard);
    }
    if (this._hasMaxTowerCard) {
      result.maxTowerCard = JsonToInt32.toJson(this._maxTowerCard);
    }
    if (this._affinityTowers.length > 0) {
      result.affinityTowers = ArrayToJson(this._affinityTowers, dcei_wildsky_card_proto.CardDefinition.Affinity);
    }
    if (this._affinityHeros.length > 0) {
      result.affinityHeros = ArrayToJson(this._affinityHeros, dcei_wildsky_card_proto.CardDefinition.Affinity);
    }
    if (this._affinitySpells.length > 0) {
      result.affinitySpells = ArrayToJson(this._affinitySpells, dcei_wildsky_card_proto.CardDefinition.Affinity);
    }
    if (this._hasCardLevelCap) {
      result.cardLevelCap = JsonToInt32.toJson(this._cardLevelCap);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get gameMode() {
    return this._hasGameMode ? this._gameMode : JsonToString.default;
  }
  get hasGameMode() {
    return this._hasGameMode;
  }
  setGameMode(path, value) {
    return {type: 'SET', path: path.concat(['gameMode']), value};
  }
  deleteGameMode(path) {
    return {type: 'DELETE', path: path.concat(['gameMode'])};
  }
  /**
   * @returns {number}
   */
  get maxHeroCard() {
    return this._hasMaxHeroCard ? this._maxHeroCard : JsonToInt32.default;
  }
  get hasMaxHeroCard() {
    return this._hasMaxHeroCard;
  }
  setMaxHeroCard(path, value) {
    return {type: 'SET', path: path.concat(['maxHeroCard']), value};
  }
  deleteMaxHeroCard(path) {
    return {type: 'DELETE', path: path.concat(['maxHeroCard'])};
  }
  /**
   * @returns {number}
   */
  get maxSpellCard() {
    return this._hasMaxSpellCard ? this._maxSpellCard : JsonToInt32.default;
  }
  get hasMaxSpellCard() {
    return this._hasMaxSpellCard;
  }
  setMaxSpellCard(path, value) {
    return {type: 'SET', path: path.concat(['maxSpellCard']), value};
  }
  deleteMaxSpellCard(path) {
    return {type: 'DELETE', path: path.concat(['maxSpellCard'])};
  }
  /**
   * @returns {number}
   */
  get maxTowerCard() {
    return this._hasMaxTowerCard ? this._maxTowerCard : JsonToInt32.default;
  }
  get hasMaxTowerCard() {
    return this._hasMaxTowerCard;
  }
  setMaxTowerCard(path, value) {
    return {type: 'SET', path: path.concat(['maxTowerCard']), value};
  }
  deleteMaxTowerCard(path) {
    return {type: 'DELETE', path: path.concat(['maxTowerCard'])};
  }
  /**
   * @returns {number[]}
   */
  get affinityTowers() {
    return this._affinityTowers;
  }
  addAffinityTowers(path, value) {
    return {type: 'ADD', path: path.concat(['affinityTowers']), value};
  }
  setAffinityTowers(path, value) {
    return {type: 'SET', path: path.concat(['affinityTowers']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardDefinition.Affinity)};
  }
  setAffinityTowersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['affinityTowers', key]), value};
  }
  deleteAffinityTowers(path) {
    return {type: 'DELETE', path: path.concat(['affinityTowers'])};
  }
  deleteAffinityTowersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['affinityTowers', key])};
  }
  /**
   * @returns {number[]}
   */
  get affinityHeros() {
    return this._affinityHeros;
  }
  addAffinityHeros(path, value) {
    return {type: 'ADD', path: path.concat(['affinityHeros']), value};
  }
  setAffinityHeros(path, value) {
    return {type: 'SET', path: path.concat(['affinityHeros']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardDefinition.Affinity)};
  }
  setAffinityHerosByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['affinityHeros', key]), value};
  }
  deleteAffinityHeros(path) {
    return {type: 'DELETE', path: path.concat(['affinityHeros'])};
  }
  deleteAffinityHerosByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['affinityHeros', key])};
  }
  /**
   * @returns {number[]}
   */
  get affinitySpells() {
    return this._affinitySpells;
  }
  addAffinitySpells(path, value) {
    return {type: 'ADD', path: path.concat(['affinitySpells']), value};
  }
  setAffinitySpells(path, value) {
    return {type: 'SET', path: path.concat(['affinitySpells']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardDefinition.Affinity)};
  }
  setAffinitySpellsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['affinitySpells', key]), value};
  }
  deleteAffinitySpells(path) {
    return {type: 'DELETE', path: path.concat(['affinitySpells'])};
  }
  deleteAffinitySpellsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['affinitySpells', key])};
  }
  /**
   * @returns {number}
   */
  get cardLevelCap() {
    return this._hasCardLevelCap ? this._cardLevelCap : JsonToInt32.default;
  }
  get hasCardLevelCap() {
    return this._hasCardLevelCap;
  }
  setCardLevelCap(path, value) {
    return {type: 'SET', path: path.concat(['cardLevelCap']), value};
  }
  deleteCardLevelCap(path) {
    return {type: 'DELETE', path: path.concat(['cardLevelCap'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "gameMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._hasGameMode = true;
              copy._gameMode = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGameMode) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._hasGameMode = false;
              copy._gameMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxHeroCard": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._hasMaxHeroCard = true;
              copy._maxHeroCard = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxHeroCard) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._hasMaxHeroCard = false;
              copy._maxHeroCard = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxSpellCard": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._hasMaxSpellCard = true;
              copy._maxSpellCard = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxSpellCard) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._hasMaxSpellCard = false;
              copy._maxSpellCard = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxTowerCard": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._hasMaxTowerCard = true;
              copy._maxTowerCard = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxTowerCard) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._hasMaxTowerCard = false;
              copy._maxTowerCard = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinityTowers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinityTowers = [];        for (let i of value) {
                copy._affinityTowers.push(dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoadoutConfig(this);
              copy._affinityTowers = copy._affinityTowers.concat([dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._affinityTowers.length === 0) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._affinityTowers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._affinityTowers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinityTowers = copy._affinityTowers.slice();
              copy._affinityTowers[path[1]] = dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoadoutConfig(this);
              copy._affinityTowers = copy._affinityTowers.slice(0, path[1]).concat(copy._affinityTowers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._affinityTowers.length) {
            return this;
          }
          const oldValue = this._affinityTowers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoadoutConfig(this);
          copy._affinityTowers = copy._affinityTowers.slice();
          copy._affinityTowers[key] = newValue;
          return copy;
        }
      }
      case "affinityHeros": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinityHeros = [];        for (let i of value) {
                copy._affinityHeros.push(dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoadoutConfig(this);
              copy._affinityHeros = copy._affinityHeros.concat([dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._affinityHeros.length === 0) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._affinityHeros = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._affinityHeros.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinityHeros = copy._affinityHeros.slice();
              copy._affinityHeros[path[1]] = dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoadoutConfig(this);
              copy._affinityHeros = copy._affinityHeros.slice(0, path[1]).concat(copy._affinityHeros.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._affinityHeros.length) {
            return this;
          }
          const oldValue = this._affinityHeros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoadoutConfig(this);
          copy._affinityHeros = copy._affinityHeros.slice();
          copy._affinityHeros[key] = newValue;
          return copy;
        }
      }
      case "affinitySpells": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinitySpells = [];        for (let i of value) {
                copy._affinitySpells.push(dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new LoadoutConfig(this);
              copy._affinitySpells = copy._affinitySpells.concat([dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._affinitySpells.length === 0) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._affinitySpells = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._affinitySpells.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._affinitySpells = copy._affinitySpells.slice();
              copy._affinitySpells[path[1]] = dcei_wildsky_card_proto.CardDefinition.Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new LoadoutConfig(this);
              copy._affinitySpells = copy._affinitySpells.slice(0, path[1]).concat(copy._affinitySpells.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._affinitySpells.length) {
            return this;
          }
          const oldValue = this._affinitySpells[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new LoadoutConfig(this);
          copy._affinitySpells = copy._affinitySpells.slice();
          copy._affinitySpells[key] = newValue;
          return copy;
        }
      }
      case "cardLevelCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new LoadoutConfig(this);
              copy._hasCardLevelCap = true;
              copy._cardLevelCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardLevelCap) {
                return this;
              }
              const copy = new LoadoutConfig(this);
              copy._hasCardLevelCap = false;
              copy._cardLevelCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {LoadoutConfig} other
   * @returns {LoadoutConfig}
   */
  merge(other) {
    const copy = new LoadoutConfig(this);
    if (other._hasGameMode) {
      copy._hasGameMode = true;
      copy._gameMode = other._gameMode;
    }
    if (other._hasMaxHeroCard) {
      copy._hasMaxHeroCard = true;
      copy._maxHeroCard = other._maxHeroCard;
    }
    if (other._hasMaxSpellCard) {
      copy._hasMaxSpellCard = true;
      copy._maxSpellCard = other._maxSpellCard;
    }
    if (other._hasMaxTowerCard) {
      copy._hasMaxTowerCard = true;
      copy._maxTowerCard = other._maxTowerCard;
    }
    copy._affinityTowers = this._affinityTowers.concat(other._affinityTowers);
    copy._affinityHeros = this._affinityHeros.concat(other._affinityHeros);
    copy._affinitySpells = this._affinitySpells.concat(other._affinitySpells);
    if (other._hasCardLevelCap) {
      copy._hasCardLevelCap = true;
      copy._cardLevelCap = other._cardLevelCap;
    }
    return copy;
  }
}
LoadoutConfig.default = new LoadoutConfig();
class LoadoutConfig_Builder {
  constructor(value) {
    this._value = new LoadoutConfig(value);
  }
  build() {
    return new LoadoutConfig(this._value);
  }
  setGameMode(value) {
    this._value._hasGameMode = true;
    this._value._gameMode = value;
    return this;
  }
  deleteGameMode() {
    this._value._hasGameMode = false;
    this._value._gameMode = null;
    return this;
  }
  setMaxHeroCard(value) {
    this._value._hasMaxHeroCard = true;
    this._value._maxHeroCard = value;
    return this;
  }
  deleteMaxHeroCard() {
    this._value._hasMaxHeroCard = false;
    this._value._maxHeroCard = null;
    return this;
  }
  setMaxSpellCard(value) {
    this._value._hasMaxSpellCard = true;
    this._value._maxSpellCard = value;
    return this;
  }
  deleteMaxSpellCard() {
    this._value._hasMaxSpellCard = false;
    this._value._maxSpellCard = null;
    return this;
  }
  setMaxTowerCard(value) {
    this._value._hasMaxTowerCard = true;
    this._value._maxTowerCard = value;
    return this;
  }
  deleteMaxTowerCard() {
    this._value._hasMaxTowerCard = false;
    this._value._maxTowerCard = null;
    return this;
  }
  addAllAffinityTowers(values) {
    this._value._affinityTowers = this._value._affinityTowers.concat(values);
    return this;
  }
  addAffinityTowers(value) {
    this._value._affinityTowers = this._value._affinityTowers.concat([value]);
    return this;
  }
  setAffinityTowers(index, value) {
    this._value._affinityTowers = this._value._affinityTowers.concat();
    this._value._affinityTowers[index] = value;
    return this;
  }
  clearAffinityTowers() {
    this._value._affinityTowers = [];
    return this;
  }
  addAllAffinityHeros(values) {
    this._value._affinityHeros = this._value._affinityHeros.concat(values);
    return this;
  }
  addAffinityHeros(value) {
    this._value._affinityHeros = this._value._affinityHeros.concat([value]);
    return this;
  }
  setAffinityHeros(index, value) {
    this._value._affinityHeros = this._value._affinityHeros.concat();
    this._value._affinityHeros[index] = value;
    return this;
  }
  clearAffinityHeros() {
    this._value._affinityHeros = [];
    return this;
  }
  addAllAffinitySpells(values) {
    this._value._affinitySpells = this._value._affinitySpells.concat(values);
    return this;
  }
  addAffinitySpells(value) {
    this._value._affinitySpells = this._value._affinitySpells.concat([value]);
    return this;
  }
  setAffinitySpells(index, value) {
    this._value._affinitySpells = this._value._affinitySpells.concat();
    this._value._affinitySpells[index] = value;
    return this;
  }
  clearAffinitySpells() {
    this._value._affinitySpells = [];
    return this;
  }
  setCardLevelCap(value) {
    this._value._hasCardLevelCap = true;
    this._value._cardLevelCap = value;
    return this;
  }
  deleteCardLevelCap() {
    this._value._hasCardLevelCap = false;
    this._value._cardLevelCap = null;
    return this;
  }
}
LoadoutConfig.Builder = LoadoutConfig_Builder;
class LoadoutConfig_WithParent {
  /**
   * @param {LoadoutConfig} value
   * @param {LoadoutConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return LoadoutConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasGameMode() {
    if (this._cachedHasGameMode === undefined) {
      if (this._value.hasGameMode) {
        this._cachedHasGameMode = true;
      } else {
        this._cachedHasGameMode = this._parent ? this._parent.hasGameMode : false;
      }
    }
    return this._cachedHasGameMode;
  }
  get gameMode() {
    if (this._cachedGameMode === undefined) {
      if (this._value.hasGameMode) {
        this._cachedGameMode = this._value.gameMode;
      } else {
        this._cachedGameMode = this._parent ? this._parent.gameMode : this._value.gameMode;
      }
    }
    return this._cachedGameMode;
  }
  get hasMaxHeroCard() {
    if (this._cachedHasMaxHeroCard === undefined) {
      if (this._value.hasMaxHeroCard) {
        this._cachedHasMaxHeroCard = true;
      } else {
        this._cachedHasMaxHeroCard = this._parent ? this._parent.hasMaxHeroCard : false;
      }
    }
    return this._cachedHasMaxHeroCard;
  }
  get maxHeroCard() {
    if (this._cachedMaxHeroCard === undefined) {
      if (this._value.hasMaxHeroCard) {
        this._cachedMaxHeroCard = this._value.maxHeroCard;
      } else {
        this._cachedMaxHeroCard = this._parent ? this._parent.maxHeroCard : this._value.maxHeroCard;
      }
    }
    return this._cachedMaxHeroCard;
  }
  get hasMaxSpellCard() {
    if (this._cachedHasMaxSpellCard === undefined) {
      if (this._value.hasMaxSpellCard) {
        this._cachedHasMaxSpellCard = true;
      } else {
        this._cachedHasMaxSpellCard = this._parent ? this._parent.hasMaxSpellCard : false;
      }
    }
    return this._cachedHasMaxSpellCard;
  }
  get maxSpellCard() {
    if (this._cachedMaxSpellCard === undefined) {
      if (this._value.hasMaxSpellCard) {
        this._cachedMaxSpellCard = this._value.maxSpellCard;
      } else {
        this._cachedMaxSpellCard = this._parent ? this._parent.maxSpellCard : this._value.maxSpellCard;
      }
    }
    return this._cachedMaxSpellCard;
  }
  get hasMaxTowerCard() {
    if (this._cachedHasMaxTowerCard === undefined) {
      if (this._value.hasMaxTowerCard) {
        this._cachedHasMaxTowerCard = true;
      } else {
        this._cachedHasMaxTowerCard = this._parent ? this._parent.hasMaxTowerCard : false;
      }
    }
    return this._cachedHasMaxTowerCard;
  }
  get maxTowerCard() {
    if (this._cachedMaxTowerCard === undefined) {
      if (this._value.hasMaxTowerCard) {
        this._cachedMaxTowerCard = this._value.maxTowerCard;
      } else {
        this._cachedMaxTowerCard = this._parent ? this._parent.maxTowerCard : this._value.maxTowerCard;
      }
    }
    return this._cachedMaxTowerCard;
  }
  get selfAffinityTowers() {
    return this._value.affinityTowers;
  }
  get inherentAffinityTowers() {
    if (!this._inherentAffinityTowers) {
      this._inherentAffinityTowers = this._parent ? this._parent.affinityTowers : [];
    }
    return this._inherentAffinityTowers;
  }
  get affinityTowers() {
    if (!this._allAffinityTowers) {
      this._allAffinityTowers = this._parent ? this._parent.affinityTowers.concat(this.selfAffinityTowers) : this.selfAffinityTowers;
    }
    return this._allAffinityTowers;
  }
  get selfAffinityHeros() {
    return this._value.affinityHeros;
  }
  get inherentAffinityHeros() {
    if (!this._inherentAffinityHeros) {
      this._inherentAffinityHeros = this._parent ? this._parent.affinityHeros : [];
    }
    return this._inherentAffinityHeros;
  }
  get affinityHeros() {
    if (!this._allAffinityHeros) {
      this._allAffinityHeros = this._parent ? this._parent.affinityHeros.concat(this.selfAffinityHeros) : this.selfAffinityHeros;
    }
    return this._allAffinityHeros;
  }
  get selfAffinitySpells() {
    return this._value.affinitySpells;
  }
  get inherentAffinitySpells() {
    if (!this._inherentAffinitySpells) {
      this._inherentAffinitySpells = this._parent ? this._parent.affinitySpells : [];
    }
    return this._inherentAffinitySpells;
  }
  get affinitySpells() {
    if (!this._allAffinitySpells) {
      this._allAffinitySpells = this._parent ? this._parent.affinitySpells.concat(this.selfAffinitySpells) : this.selfAffinitySpells;
    }
    return this._allAffinitySpells;
  }
  get hasCardLevelCap() {
    if (this._cachedHasCardLevelCap === undefined) {
      if (this._value.hasCardLevelCap) {
        this._cachedHasCardLevelCap = true;
      } else {
        this._cachedHasCardLevelCap = this._parent ? this._parent.hasCardLevelCap : false;
      }
    }
    return this._cachedHasCardLevelCap;
  }
  get cardLevelCap() {
    if (this._cachedCardLevelCap === undefined) {
      if (this._value.hasCardLevelCap) {
        this._cachedCardLevelCap = this._value.cardLevelCap;
      } else {
        this._cachedCardLevelCap = this._parent ? this._parent.cardLevelCap : this._value.cardLevelCap;
      }
    }
    return this._cachedCardLevelCap;
  }
  update(current, parent) {
    const result = new LoadoutConfig_WithParent(current, parent);
    return result;
  }
}
LoadoutConfig_WithParent.default = new LoadoutConfig_WithParent(LoadoutConfig.default, null);
LoadoutConfig.WithParent = LoadoutConfig_WithParent;
class LoadoutConfig_Descriptor {
  get gameMode() {
    if (!this._gameMode) {
      this._gameMode = {
        name: "gameMode",
        Name: "GameMode",
        number: 1,
        protoType: 9,
        protoName: "game_mode",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gameMode;
  }
  get maxHeroCard() {
    if (!this._maxHeroCard) {
      this._maxHeroCard = {
        name: "maxHeroCard",
        Name: "MaxHeroCard",
        number: 2,
        protoType: 5,
        protoName: "max_hero_card",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxHeroCard;
  }
  get maxSpellCard() {
    if (!this._maxSpellCard) {
      this._maxSpellCard = {
        name: "maxSpellCard",
        Name: "MaxSpellCard",
        number: 3,
        protoType: 5,
        protoName: "max_spell_card",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxSpellCard;
  }
  get maxTowerCard() {
    if (!this._maxTowerCard) {
      this._maxTowerCard = {
        name: "maxTowerCard",
        Name: "MaxTowerCard",
        number: 4,
        protoType: 5,
        protoName: "max_tower_card",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxTowerCard;
  }
  get affinityTowers() {
    if (!this._affinityTowers) {
      this._affinityTowers = {
        name: "affinityTowers",
        Name: "AffinityTowers",
        number: 5,
        protoType: 14,
        protoName: "affinity_towers",
        type: dcei_wildsky_card_proto.CardDefinition.Affinity,
        isRepeated: true,
        options: {
          comments: "Follows the older of tower slots, the first element in the list will be the affinity for the first tower slot",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityTowers;
  }
  get affinityHeros() {
    if (!this._affinityHeros) {
      this._affinityHeros = {
        name: "affinityHeros",
        Name: "AffinityHeros",
        number: 6,
        protoType: 14,
        protoName: "affinity_heros",
        type: dcei_wildsky_card_proto.CardDefinition.Affinity,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityHeros;
  }
  get affinitySpells() {
    if (!this._affinitySpells) {
      this._affinitySpells = {
        name: "affinitySpells",
        Name: "AffinitySpells",
        number: 7,
        protoType: 14,
        protoName: "affinity_spells",
        type: dcei_wildsky_card_proto.CardDefinition.Affinity,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinitySpells;
  }
  get cardLevelCap() {
    if (!this._cardLevelCap) {
      this._cardLevelCap = {
        name: "cardLevelCap",
        Name: "CardLevelCap",
        number: 8,
        protoType: 5,
        protoName: "card_level_cap",
        type: JsonToInt32,
        options: {
          comments: "no cap if <= 0",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardLevelCap;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.gameMode,
        this.maxHeroCard,
        this.maxSpellCard,
        this.maxTowerCard,
        this.affinityTowers,
        this.affinityHeros,
        this.affinitySpells,
        this.cardLevelCap,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForGameMode",
        Name: "DummyOneofForGameMode",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxHeroCard",
        Name: "DummyOneofForMaxHeroCard",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxSpellCard",
        Name: "DummyOneofForMaxSpellCard",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxTowerCard",
        Name: "DummyOneofForMaxTowerCard",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardLevelCap",
        Name: "DummyOneofForCardLevelCap",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
LoadoutConfig.descriptor = new LoadoutConfig_Descriptor();
export class Map {
  get descriptor() {
    return Map.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasPath = false;
    this._path = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasCreepLevel = false;
    this._creepLevel = null;
    this._enemyTypes = [];
    this._hasLoadoutConfig = false;
    this._loadoutConfig = null;
    this._fixedCardProgression = [];
    this._showcaseCardProgression = [];
    this._hasVictoryShowcaseCardName = false;
    this._victoryShowcaseCardName = null;
    this._hasVictoryShowcaseCardPortrait = false;
    this._victoryShowcaseCardPortrait = null;
    this._hasEnergyCost = false;
    this._energyCost = null;
    this._hasDisableComment = false;
    this._disableComment = null;
    this._hasDisableSpotlight = false;
    this._disableSpotlight = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasPath) return false;
    if (this._hasDisplayName) return false;
    if (this._hasCreepLevel) return false;
    if (this._enemyTypes.length > 0) return false;
    if (this._hasLoadoutConfig && !this._loadoutConfig.isEmpty()) return false;
    if (this._fixedCardProgression.length > 0) return false;
    if (this._showcaseCardProgression.length > 0) return false;
    if (this._hasVictoryShowcaseCardName) return false;
    if (this._hasVictoryShowcaseCardPortrait) return false;
    if (this._hasEnergyCost) return false;
    if (this._hasDisableComment) return false;
    if (this._hasDisableSpotlight) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Map) {
      return value;
    }
    return Map.fromJson(value);
  }
  static fromJson(json) {
    const result = new Map();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    result._enemyTypes = JsonToList(json.enemyTypes, dcei_wildsky_enemy_type_proto.EnemyType);
    if (json.loadoutConfig != null) {
      result._hasLoadoutConfig = true;
      result._loadoutConfig = LoadoutConfig.fromJson(json.loadoutConfig);
    }
    result._fixedCardProgression = JsonToList(json.fixedCardProgression, dcei_wildsky_card_proto.CardProgression);
    result._showcaseCardProgression = JsonToList(json.showcaseCardProgression, dcei_wildsky_card_proto.CardProgression);
    if (json.victoryShowcaseCardName != null) {
      result._hasVictoryShowcaseCardName = true;
      result._victoryShowcaseCardName = JsonToString.fromJson(json.victoryShowcaseCardName);
    }
    if (json.victoryShowcaseCardPortrait != null) {
      result._hasVictoryShowcaseCardPortrait = true;
      result._victoryShowcaseCardPortrait = JsonToString.fromJson(json.victoryShowcaseCardPortrait);
    }
    if (json.energyCost != null) {
      result._hasEnergyCost = true;
      result._energyCost = JsonToInt32.fromJson(json.energyCost);
    }
    if (json.disableComment != null) {
      result._hasDisableComment = true;
      result._disableComment = JsonToBoolean.fromJson(json.disableComment);
    }
    if (json.disableSpotlight != null) {
      result._hasDisableSpotlight = true;
      result._disableSpotlight = JsonToBoolean.fromJson(json.disableSpotlight);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    if (this._enemyTypes.length > 0) {
      result.enemyTypes = ArrayToJson(this._enemyTypes, dcei_wildsky_enemy_type_proto.EnemyType);
    }
    if (this._hasLoadoutConfig && !this._loadoutConfig.isEmpty()) {
      result.loadoutConfig = LoadoutConfig.toJson(this._loadoutConfig);
    }
    if (this._fixedCardProgression.length > 0) {
      result.fixedCardProgression = ArrayToJson(this._fixedCardProgression, dcei_wildsky_card_proto.CardProgression);
    }
    if (this._showcaseCardProgression.length > 0) {
      result.showcaseCardProgression = ArrayToJson(this._showcaseCardProgression, dcei_wildsky_card_proto.CardProgression);
    }
    if (this._hasVictoryShowcaseCardName) {
      result.victoryShowcaseCardName = JsonToString.toJson(this._victoryShowcaseCardName);
    }
    if (this._hasVictoryShowcaseCardPortrait) {
      result.victoryShowcaseCardPortrait = JsonToString.toJson(this._victoryShowcaseCardPortrait);
    }
    if (this._hasEnergyCost) {
      result.energyCost = JsonToInt32.toJson(this._energyCost);
    }
    if (this._hasDisableComment) {
      result.disableComment = JsonToBoolean.toJson(this._disableComment);
    }
    if (this._hasDisableSpotlight) {
      result.disableSpotlight = JsonToBoolean.toJson(this._disableSpotlight);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  /**
   * @returns {number[]}
   */
  get enemyTypes() {
    return this._enemyTypes;
  }
  addEnemyTypes(path, value) {
    return {type: 'ADD', path: path.concat(['enemyTypes']), value};
  }
  setEnemyTypes(path, value) {
    return {type: 'SET', path: path.concat(['enemyTypes']), value: ArrayToJson(value, dcei_wildsky_enemy_type_proto.EnemyType)};
  }
  setEnemyTypesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['enemyTypes', key]), value};
  }
  deleteEnemyTypes(path) {
    return {type: 'DELETE', path: path.concat(['enemyTypes'])};
  }
  deleteEnemyTypesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['enemyTypes', key])};
  }
  /**
   * @returns {LoadoutConfig}
   */
  get loadoutConfig() {
    return this._hasLoadoutConfig ? this._loadoutConfig : LoadoutConfig.default;
  }
  get hasLoadoutConfig() {
    return this._hasLoadoutConfig;
  }
  setLoadoutConfig(path, value) {
    return {type: 'SET', path: path.concat(['loadoutConfig']), value: value.toJson()};
  }
  deleteLoadoutConfig(path) {
    return {type: 'DELETE', path: path.concat(['loadoutConfig'])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardProgression[]}
   */
  get fixedCardProgression() {
    return this._fixedCardProgression;
  }
  addFixedCardProgression(path, value) {
    return {type: 'ADD', path: path.concat(['fixedCardProgression']), value: value.toJson()};
  }
  setFixedCardProgression(path, value) {
    return {type: 'SET', path: path.concat(['fixedCardProgression']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardProgression)};
  }
  setFixedCardProgressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['fixedCardProgression', key]), value: value.toJson()};
  }
  deleteFixedCardProgression(path) {
    return {type: 'DELETE', path: path.concat(['fixedCardProgression'])};
  }
  deleteFixedCardProgressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['fixedCardProgression', key])};
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardProgression[]}
   */
  get showcaseCardProgression() {
    return this._showcaseCardProgression;
  }
  addShowcaseCardProgression(path, value) {
    return {type: 'ADD', path: path.concat(['showcaseCardProgression']), value: value.toJson()};
  }
  setShowcaseCardProgression(path, value) {
    return {type: 'SET', path: path.concat(['showcaseCardProgression']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardProgression)};
  }
  setShowcaseCardProgressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['showcaseCardProgression', key]), value: value.toJson()};
  }
  deleteShowcaseCardProgression(path) {
    return {type: 'DELETE', path: path.concat(['showcaseCardProgression'])};
  }
  deleteShowcaseCardProgressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['showcaseCardProgression', key])};
  }
  /**
   * @returns {string}
   */
  get victoryShowcaseCardName() {
    return this._hasVictoryShowcaseCardName ? this._victoryShowcaseCardName : JsonToString.default;
  }
  get hasVictoryShowcaseCardName() {
    return this._hasVictoryShowcaseCardName;
  }
  setVictoryShowcaseCardName(path, value) {
    return {type: 'SET', path: path.concat(['victoryShowcaseCardName']), value};
  }
  deleteVictoryShowcaseCardName(path) {
    return {type: 'DELETE', path: path.concat(['victoryShowcaseCardName'])};
  }
  /**
   * @returns {string}
   */
  get victoryShowcaseCardPortrait() {
    return this._hasVictoryShowcaseCardPortrait ? this._victoryShowcaseCardPortrait : JsonToString.default;
  }
  get hasVictoryShowcaseCardPortrait() {
    return this._hasVictoryShowcaseCardPortrait;
  }
  setVictoryShowcaseCardPortrait(path, value) {
    return {type: 'SET', path: path.concat(['victoryShowcaseCardPortrait']), value};
  }
  deleteVictoryShowcaseCardPortrait(path) {
    return {type: 'DELETE', path: path.concat(['victoryShowcaseCardPortrait'])};
  }
  /**
   * @returns {number}
   */
  get energyCost() {
    return this._hasEnergyCost ? this._energyCost : JsonToInt32.default;
  }
  get hasEnergyCost() {
    return this._hasEnergyCost;
  }
  setEnergyCost(path, value) {
    return {type: 'SET', path: path.concat(['energyCost']), value};
  }
  deleteEnergyCost(path) {
    return {type: 'DELETE', path: path.concat(['energyCost'])};
  }
  /**
   * @returns {boolean}
   */
  get disableComment() {
    return this._hasDisableComment ? this._disableComment : JsonToBoolean.default;
  }
  get hasDisableComment() {
    return this._hasDisableComment;
  }
  setDisableComment(path, value) {
    return {type: 'SET', path: path.concat(['disableComment']), value};
  }
  deleteDisableComment(path) {
    return {type: 'DELETE', path: path.concat(['disableComment'])};
  }
  /**
   * @returns {boolean}
   */
  get disableSpotlight() {
    return this._hasDisableSpotlight ? this._disableSpotlight : JsonToBoolean.default;
  }
  get hasDisableSpotlight() {
    return this._hasDisableSpotlight;
  }
  setDisableSpotlight(path, value) {
    return {type: 'SET', path: path.concat(['disableSpotlight']), value};
  }
  deleteDisableSpotlight(path) {
    return {type: 'DELETE', path: path.concat(['disableSpotlight'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new Map(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new Map(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new Map(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new Map(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enemyTypes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._enemyTypes = [];        for (let i of value) {
                copy._enemyTypes.push(dcei_wildsky_enemy_type_proto.EnemyType.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Map(this);
              copy._enemyTypes = copy._enemyTypes.concat([dcei_wildsky_enemy_type_proto.EnemyType.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._enemyTypes.length === 0) {
                return this;
              }
              const copy = new Map(this);
              copy._enemyTypes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._enemyTypes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._enemyTypes = copy._enemyTypes.slice();
              copy._enemyTypes[path[1]] = dcei_wildsky_enemy_type_proto.EnemyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Map(this);
              copy._enemyTypes = copy._enemyTypes.slice(0, path[1]).concat(copy._enemyTypes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._enemyTypes.length) {
            return this;
          }
          const oldValue = this._enemyTypes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Map(this);
          copy._enemyTypes = copy._enemyTypes.slice();
          copy._enemyTypes[key] = newValue;
          return copy;
        }
      }
      case "loadoutConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasLoadoutConfig = true;
              copy._loadoutConfig = LoadoutConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLoadoutConfig) {
                return this;
              }
              const copy = new Map(this);
              copy._hasLoadoutConfig = false;
              copy._loadoutConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLoadoutConfig) {
            const copy = new Map(this);
            copy._hasLoadoutConfig = true;
            copy._loadoutConfig = LoadoutConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._loadoutConfig.apply(type, path.slice(1), value);
          if (newValue === this._loadoutConfig) {
            return this;
          }
          const copy = new Map(this);
          copy._loadoutConfig = copy._loadoutConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "fixedCardProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._fixedCardProgression = [];        for (let i of value) {
                copy._fixedCardProgression.push(dcei_wildsky_card_proto.CardProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Map(this);
              copy._fixedCardProgression = copy._fixedCardProgression.concat([dcei_wildsky_card_proto.CardProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._fixedCardProgression.length === 0) {
                return this;
              }
              const copy = new Map(this);
              copy._fixedCardProgression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._fixedCardProgression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._fixedCardProgression = copy._fixedCardProgression.slice();
              copy._fixedCardProgression[path[1]] = dcei_wildsky_card_proto.CardProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Map(this);
              copy._fixedCardProgression = copy._fixedCardProgression.slice(0, path[1]).concat(copy._fixedCardProgression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._fixedCardProgression.length) {
            return this;
          }
          const oldValue = this._fixedCardProgression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Map(this);
          copy._fixedCardProgression = copy._fixedCardProgression.slice();
          copy._fixedCardProgression[key] = newValue;
          return copy;
        }
      }
      case "showcaseCardProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._showcaseCardProgression = [];        for (let i of value) {
                copy._showcaseCardProgression.push(dcei_wildsky_card_proto.CardProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Map(this);
              copy._showcaseCardProgression = copy._showcaseCardProgression.concat([dcei_wildsky_card_proto.CardProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._showcaseCardProgression.length === 0) {
                return this;
              }
              const copy = new Map(this);
              copy._showcaseCardProgression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._showcaseCardProgression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._showcaseCardProgression = copy._showcaseCardProgression.slice();
              copy._showcaseCardProgression[path[1]] = dcei_wildsky_card_proto.CardProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Map(this);
              copy._showcaseCardProgression = copy._showcaseCardProgression.slice(0, path[1]).concat(copy._showcaseCardProgression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._showcaseCardProgression.length) {
            return this;
          }
          const oldValue = this._showcaseCardProgression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Map(this);
          copy._showcaseCardProgression = copy._showcaseCardProgression.slice();
          copy._showcaseCardProgression[key] = newValue;
          return copy;
        }
      }
      case "victoryShowcaseCardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasVictoryShowcaseCardName = true;
              copy._victoryShowcaseCardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVictoryShowcaseCardName) {
                return this;
              }
              const copy = new Map(this);
              copy._hasVictoryShowcaseCardName = false;
              copy._victoryShowcaseCardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "victoryShowcaseCardPortrait": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasVictoryShowcaseCardPortrait = true;
              copy._victoryShowcaseCardPortrait = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVictoryShowcaseCardPortrait) {
                return this;
              }
              const copy = new Map(this);
              copy._hasVictoryShowcaseCardPortrait = false;
              copy._victoryShowcaseCardPortrait = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "energyCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasEnergyCost = true;
              copy._energyCost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnergyCost) {
                return this;
              }
              const copy = new Map(this);
              copy._hasEnergyCost = false;
              copy._energyCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableComment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasDisableComment = true;
              copy._disableComment = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableComment) {
                return this;
              }
              const copy = new Map(this);
              copy._hasDisableComment = false;
              copy._disableComment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disableSpotlight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Map(this);
              copy._hasDisableSpotlight = true;
              copy._disableSpotlight = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisableSpotlight) {
                return this;
              }
              const copy = new Map(this);
              copy._hasDisableSpotlight = false;
              copy._disableSpotlight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Map} other
   * @returns {Map}
   */
  merge(other) {
    const copy = new Map(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    copy._enemyTypes = this._enemyTypes.concat(other._enemyTypes);
    if (other._hasLoadoutConfig) {
      if (copy._hasLoadoutConfig) {
        copy._loadoutConfig = copy.loadoutConfig.merge(other.loadoutConfig);
      } else {
        copy._loadoutConfig = other._loadoutConfig;
      }
      copy._hasLoadoutConfig = true;
    }
    copy._fixedCardProgression = this._fixedCardProgression.concat(other._fixedCardProgression);
    copy._showcaseCardProgression = this._showcaseCardProgression.concat(other._showcaseCardProgression);
    if (other._hasVictoryShowcaseCardName) {
      copy._hasVictoryShowcaseCardName = true;
      copy._victoryShowcaseCardName = other._victoryShowcaseCardName;
    }
    if (other._hasVictoryShowcaseCardPortrait) {
      copy._hasVictoryShowcaseCardPortrait = true;
      copy._victoryShowcaseCardPortrait = other._victoryShowcaseCardPortrait;
    }
    if (other._hasEnergyCost) {
      copy._hasEnergyCost = true;
      copy._energyCost = other._energyCost;
    }
    if (other._hasDisableComment) {
      copy._hasDisableComment = true;
      copy._disableComment = other._disableComment;
    }
    if (other._hasDisableSpotlight) {
      copy._hasDisableSpotlight = true;
      copy._disableSpotlight = other._disableSpotlight;
    }
    return copy;
  }
}
Map.default = new Map();
class Map_Builder {
  constructor(value) {
    this._value = new Map(value);
  }
  build() {
    return new Map(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
  addAllEnemyTypes(values) {
    this._value._enemyTypes = this._value._enemyTypes.concat(values);
    return this;
  }
  addEnemyTypes(value) {
    this._value._enemyTypes = this._value._enemyTypes.concat([value]);
    return this;
  }
  setEnemyTypes(index, value) {
    this._value._enemyTypes = this._value._enemyTypes.concat();
    this._value._enemyTypes[index] = value;
    return this;
  }
  clearEnemyTypes() {
    this._value._enemyTypes = [];
    return this;
  }
  setLoadoutConfig(value) {
    this._value._hasLoadoutConfig = true;
    this._value._loadoutConfig = value;
    return this;
  }
  deleteLoadoutConfig() {
    this._value._hasLoadoutConfig = false;
    this._value._loadoutConfig = null;
    return this;
  }
  addAllFixedCardProgression(values) {
    this._value._fixedCardProgression = this._value._fixedCardProgression.concat(values);
    return this;
  }
  addFixedCardProgression(value) {
    this._value._fixedCardProgression = this._value._fixedCardProgression.concat([value]);
    return this;
  }
  setFixedCardProgression(index, value) {
    this._value._fixedCardProgression = this._value._fixedCardProgression.concat();
    this._value._fixedCardProgression[index] = value;
    return this;
  }
  clearFixedCardProgression() {
    this._value._fixedCardProgression = [];
    return this;
  }
  addAllShowcaseCardProgression(values) {
    this._value._showcaseCardProgression = this._value._showcaseCardProgression.concat(values);
    return this;
  }
  addShowcaseCardProgression(value) {
    this._value._showcaseCardProgression = this._value._showcaseCardProgression.concat([value]);
    return this;
  }
  setShowcaseCardProgression(index, value) {
    this._value._showcaseCardProgression = this._value._showcaseCardProgression.concat();
    this._value._showcaseCardProgression[index] = value;
    return this;
  }
  clearShowcaseCardProgression() {
    this._value._showcaseCardProgression = [];
    return this;
  }
  setVictoryShowcaseCardName(value) {
    this._value._hasVictoryShowcaseCardName = true;
    this._value._victoryShowcaseCardName = value;
    return this;
  }
  deleteVictoryShowcaseCardName() {
    this._value._hasVictoryShowcaseCardName = false;
    this._value._victoryShowcaseCardName = null;
    return this;
  }
  setVictoryShowcaseCardPortrait(value) {
    this._value._hasVictoryShowcaseCardPortrait = true;
    this._value._victoryShowcaseCardPortrait = value;
    return this;
  }
  deleteVictoryShowcaseCardPortrait() {
    this._value._hasVictoryShowcaseCardPortrait = false;
    this._value._victoryShowcaseCardPortrait = null;
    return this;
  }
  setEnergyCost(value) {
    this._value._hasEnergyCost = true;
    this._value._energyCost = value;
    return this;
  }
  deleteEnergyCost() {
    this._value._hasEnergyCost = false;
    this._value._energyCost = null;
    return this;
  }
  setDisableComment(value) {
    this._value._hasDisableComment = true;
    this._value._disableComment = value;
    return this;
  }
  deleteDisableComment() {
    this._value._hasDisableComment = false;
    this._value._disableComment = null;
    return this;
  }
  setDisableSpotlight(value) {
    this._value._hasDisableSpotlight = true;
    this._value._disableSpotlight = value;
    return this;
  }
  deleteDisableSpotlight() {
    this._value._hasDisableSpotlight = false;
    this._value._disableSpotlight = null;
    return this;
  }
}
Map.Builder = Map_Builder;
class Map_WithParent {
  /**
   * @param {Map} value
   * @param {Map_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Map.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  get selfEnemyTypes() {
    return this._value.enemyTypes;
  }
  get inherentEnemyTypes() {
    if (!this._inherentEnemyTypes) {
      this._inherentEnemyTypes = this._parent ? this._parent.enemyTypes : [];
    }
    return this._inherentEnemyTypes;
  }
  get enemyTypes() {
    if (!this._allEnemyTypes) {
      this._allEnemyTypes = this._parent ? this._parent.enemyTypes.concat(this.selfEnemyTypes) : this.selfEnemyTypes;
    }
    return this._allEnemyTypes;
  }
  get hasLoadoutConfig() {
    if (this._cachedHasLoadoutConfig === undefined) {
      if (this._value.hasLoadoutConfig) {
        this._cachedHasLoadoutConfig = true;
      } else {
        this._cachedHasLoadoutConfig = this._parent ? this._parent.hasLoadoutConfig : false;
      }
    }
    return this._cachedHasLoadoutConfig;
  }
  get loadoutConfig() {
    if (!this._cachedLoadoutConfig) {
      if (this._value.hasLoadoutConfig) {
        this._cachedLoadoutConfig = new LoadoutConfig.WithParent(this._value.loadoutConfig, this._parent && this._parent.hasLoadoutConfig ? this._parent.loadoutConfig : null);
      } else {
        this._cachedLoadoutConfig = this._parent ? new LoadoutConfig.WithParent(LoadoutConfig.default, this._parent.loadoutConfig) : LoadoutConfig.WithParent.default;
      }
    }
    return this._cachedLoadoutConfig;
  }
  get selfFixedCardProgression() {
    if (!this._selfFixedCardProgression) {
      this._selfFixedCardProgression = [];
      for (let i of this._value.fixedCardProgression) {
        this._selfFixedCardProgression.push(new dcei_wildsky_card_proto.CardProgression.WithParent(i, null));
      }
    }
    return this._selfFixedCardProgression;
  }
  get inherentFixedCardProgression() {
    if (!this._inherentFixedCardProgression) {
      this._inherentFixedCardProgression = this._parent ? this._parent.fixedCardProgression : [];
    }
    return this._inherentFixedCardProgression;
  }
  get fixedCardProgression() {
    if (!this._allFixedCardProgression) {
      this._allFixedCardProgression = this._parent ? this._parent.fixedCardProgression.concat(this.selfFixedCardProgression) : this.selfFixedCardProgression;
    }
    return this._allFixedCardProgression;
  }
  get selfShowcaseCardProgression() {
    if (!this._selfShowcaseCardProgression) {
      this._selfShowcaseCardProgression = [];
      for (let i of this._value.showcaseCardProgression) {
        this._selfShowcaseCardProgression.push(new dcei_wildsky_card_proto.CardProgression.WithParent(i, null));
      }
    }
    return this._selfShowcaseCardProgression;
  }
  get inherentShowcaseCardProgression() {
    if (!this._inherentShowcaseCardProgression) {
      this._inherentShowcaseCardProgression = this._parent ? this._parent.showcaseCardProgression : [];
    }
    return this._inherentShowcaseCardProgression;
  }
  get showcaseCardProgression() {
    if (!this._allShowcaseCardProgression) {
      this._allShowcaseCardProgression = this._parent ? this._parent.showcaseCardProgression.concat(this.selfShowcaseCardProgression) : this.selfShowcaseCardProgression;
    }
    return this._allShowcaseCardProgression;
  }
  get hasVictoryShowcaseCardName() {
    if (this._cachedHasVictoryShowcaseCardName === undefined) {
      if (this._value.hasVictoryShowcaseCardName) {
        this._cachedHasVictoryShowcaseCardName = true;
      } else {
        this._cachedHasVictoryShowcaseCardName = this._parent ? this._parent.hasVictoryShowcaseCardName : false;
      }
    }
    return this._cachedHasVictoryShowcaseCardName;
  }
  get victoryShowcaseCardName() {
    if (this._cachedVictoryShowcaseCardName === undefined) {
      if (this._value.hasVictoryShowcaseCardName) {
        this._cachedVictoryShowcaseCardName = this._value.victoryShowcaseCardName;
      } else {
        this._cachedVictoryShowcaseCardName = this._parent ? this._parent.victoryShowcaseCardName : this._value.victoryShowcaseCardName;
      }
    }
    return this._cachedVictoryShowcaseCardName;
  }
  get hasVictoryShowcaseCardPortrait() {
    if (this._cachedHasVictoryShowcaseCardPortrait === undefined) {
      if (this._value.hasVictoryShowcaseCardPortrait) {
        this._cachedHasVictoryShowcaseCardPortrait = true;
      } else {
        this._cachedHasVictoryShowcaseCardPortrait = this._parent ? this._parent.hasVictoryShowcaseCardPortrait : false;
      }
    }
    return this._cachedHasVictoryShowcaseCardPortrait;
  }
  get victoryShowcaseCardPortrait() {
    if (this._cachedVictoryShowcaseCardPortrait === undefined) {
      if (this._value.hasVictoryShowcaseCardPortrait) {
        this._cachedVictoryShowcaseCardPortrait = this._value.victoryShowcaseCardPortrait;
      } else {
        this._cachedVictoryShowcaseCardPortrait = this._parent ? this._parent.victoryShowcaseCardPortrait : this._value.victoryShowcaseCardPortrait;
      }
    }
    return this._cachedVictoryShowcaseCardPortrait;
  }
  get hasEnergyCost() {
    if (this._cachedHasEnergyCost === undefined) {
      if (this._value.hasEnergyCost) {
        this._cachedHasEnergyCost = true;
      } else {
        this._cachedHasEnergyCost = this._parent ? this._parent.hasEnergyCost : false;
      }
    }
    return this._cachedHasEnergyCost;
  }
  get energyCost() {
    if (this._cachedEnergyCost === undefined) {
      if (this._value.hasEnergyCost) {
        this._cachedEnergyCost = this._value.energyCost;
      } else {
        this._cachedEnergyCost = this._parent ? this._parent.energyCost : this._value.energyCost;
      }
    }
    return this._cachedEnergyCost;
  }
  get hasDisableComment() {
    if (this._cachedHasDisableComment === undefined) {
      if (this._value.hasDisableComment) {
        this._cachedHasDisableComment = true;
      } else {
        this._cachedHasDisableComment = this._parent ? this._parent.hasDisableComment : false;
      }
    }
    return this._cachedHasDisableComment;
  }
  get disableComment() {
    if (this._cachedDisableComment === undefined) {
      if (this._value.hasDisableComment) {
        this._cachedDisableComment = this._value.disableComment;
      } else {
        this._cachedDisableComment = this._parent ? this._parent.disableComment : this._value.disableComment;
      }
    }
    return this._cachedDisableComment;
  }
  get hasDisableSpotlight() {
    if (this._cachedHasDisableSpotlight === undefined) {
      if (this._value.hasDisableSpotlight) {
        this._cachedHasDisableSpotlight = true;
      } else {
        this._cachedHasDisableSpotlight = this._parent ? this._parent.hasDisableSpotlight : false;
      }
    }
    return this._cachedHasDisableSpotlight;
  }
  get disableSpotlight() {
    if (this._cachedDisableSpotlight === undefined) {
      if (this._value.hasDisableSpotlight) {
        this._cachedDisableSpotlight = this._value.disableSpotlight;
      } else {
        this._cachedDisableSpotlight = this._parent ? this._parent.disableSpotlight : this._value.disableSpotlight;
      }
    }
    return this._cachedDisableSpotlight;
  }
  update(current, parent) {
    const result = new Map_WithParent(current, parent);
    if (this._cachedLoadoutConfig && this._value.hasLoadoutConfig && current.hasLoadoutConfig) {
      if (this._value.loadoutConfig === current.loadoutConfig && this._parent === parent) {
        result._cachedLoadoutConfig = this._cachedLoadoutConfig;
      } else {
        result._cachedLoadoutConfig = this._cachedLoadoutConfig.update(current.loadoutConfig, parent && parent.hasLoadoutConfig ? parent.loadoutConfig : null);
      }
    }
    if (this._selfFixedCardProgression) {
      if (this._value.fixedCardProgression === current.fixedCardProgression) {
        result._selfFixedCardProgression = this._selfFixedCardProgression;
      } else {
        result._selfFixedCardProgression = [];
        for (let i = 0; i < current.fixedCardProgression.length; i++) {
          const oldValue = this._value.fixedCardProgression[i];
          if (oldValue) {
            const oldCache = this._selfFixedCardProgression[i];
            if (oldValue === current.fixedCardProgression[i]) {
              result._selfFixedCardProgression[i] = oldCache;
            } else {
              result._selfFixedCardProgression[i] = oldCache.update(current.fixedCardProgression[i], null);
            }
          } else {
            result._selfFixedCardProgression[i] = new dcei_wildsky_card_proto.CardProgression.WithParent(current.fixedCardProgression[i], null);
          }
        }
      }
    }
    if (this._selfShowcaseCardProgression) {
      if (this._value.showcaseCardProgression === current.showcaseCardProgression) {
        result._selfShowcaseCardProgression = this._selfShowcaseCardProgression;
      } else {
        result._selfShowcaseCardProgression = [];
        for (let i = 0; i < current.showcaseCardProgression.length; i++) {
          const oldValue = this._value.showcaseCardProgression[i];
          if (oldValue) {
            const oldCache = this._selfShowcaseCardProgression[i];
            if (oldValue === current.showcaseCardProgression[i]) {
              result._selfShowcaseCardProgression[i] = oldCache;
            } else {
              result._selfShowcaseCardProgression[i] = oldCache.update(current.showcaseCardProgression[i], null);
            }
          } else {
            result._selfShowcaseCardProgression[i] = new dcei_wildsky_card_proto.CardProgression.WithParent(current.showcaseCardProgression[i], null);
          }
        }
      }
    }
    return result;
  }
}
Map_WithParent.default = new Map_WithParent(Map.default, null);
Map.WithParent = Map_WithParent;
class Map_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 2,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 3,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 4,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get enemyTypes() {
    if (!this._enemyTypes) {
      this._enemyTypes = {
        name: "enemyTypes",
        Name: "EnemyTypes",
        number: 5,
        protoType: 14,
        protoName: "enemy_types",
        type: dcei_wildsky_enemy_type_proto.EnemyType,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enemyTypes;
  }
  get loadoutConfig() {
    if (!this._loadoutConfig) {
      this._loadoutConfig = {
        name: "loadoutConfig",
        Name: "LoadoutConfig",
        number: 6,
        protoType: 11,
        protoName: "loadout_config",
        type: LoadoutConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._loadoutConfig;
  }
  get fixedCardProgression() {
    if (!this._fixedCardProgression) {
      this._fixedCardProgression = {
        name: "fixedCardProgression",
        Name: "FixedCardProgression",
        number: 13,
        protoType: 11,
        protoName: "fixed_card_progression",
        type: dcei_wildsky_card_proto.CardProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fixedCardProgression;
  }
  get showcaseCardProgression() {
    if (!this._showcaseCardProgression) {
      this._showcaseCardProgression = {
        name: "showcaseCardProgression",
        Name: "ShowcaseCardProgression",
        number: 7,
        protoType: 11,
        protoName: "showcase_card_progression",
        type: dcei_wildsky_card_proto.CardProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showcaseCardProgression;
  }
  get victoryShowcaseCardName() {
    if (!this._victoryShowcaseCardName) {
      this._victoryShowcaseCardName = {
        name: "victoryShowcaseCardName",
        Name: "VictoryShowcaseCardName",
        number: 8,
        protoType: 9,
        protoName: "victory_showcase_card_name",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._victoryShowcaseCardName;
  }
  get victoryShowcaseCardPortrait() {
    if (!this._victoryShowcaseCardPortrait) {
      this._victoryShowcaseCardPortrait = {
        name: "victoryShowcaseCardPortrait",
        Name: "VictoryShowcaseCardPortrait",
        number: 9,
        protoType: 9,
        protoName: "victory_showcase_card_portrait",
        type: JsonToString,
        options: {
          valueDropdown: "ShowcaseCardPortraits",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._victoryShowcaseCardPortrait;
  }
  get energyCost() {
    if (!this._energyCost) {
      this._energyCost = {
        name: "energyCost",
        Name: "EnergyCost",
        number: 10,
        protoType: 5,
        protoName: "energy_cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._energyCost;
  }
  get disableComment() {
    if (!this._disableComment) {
      this._disableComment = {
        name: "disableComment",
        Name: "DisableComment",
        number: 11,
        protoType: 8,
        protoName: "disable_comment",
        type: JsonToBoolean,
        options: {
          comments: "By default, comment is enabled for all maps since it\'s majority case",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableComment;
  }
  get disableSpotlight() {
    if (!this._disableSpotlight) {
      this._disableSpotlight = {
        name: "disableSpotlight",
        Name: "DisableSpotlight",
        number: 12,
        protoType: 8,
        protoName: "disable_spotlight",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disableSpotlight;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.path,
        this.displayName,
        this.creepLevel,
        this.enemyTypes,
        this.loadoutConfig,
        this.fixedCardProgression,
        this.showcaseCardProgression,
        this.victoryShowcaseCardName,
        this.victoryShowcaseCardPortrait,
        this.energyCost,
        this.disableComment,
        this.disableSpotlight,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLoadoutConfig",
        Name: "DummyOneofForLoadoutConfig",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVictoryShowcaseCardName",
        Name: "DummyOneofForVictoryShowcaseCardName",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVictoryShowcaseCardPortrait",
        Name: "DummyOneofForVictoryShowcaseCardPortrait",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnergyCost",
        Name: "DummyOneofForEnergyCost",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableComment",
        Name: "DummyOneofForDisableComment",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisableSpotlight",
        Name: "DummyOneofForDisableSpotlight",
        fields: [
          this.fields[12],
        ],
      });
    }
    return this._oneofs;
  }
}
Map.descriptor = new Map_Descriptor();
export class MapData {
  get descriptor() {
    return MapData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._maps = [];
  }
  isEmpty() {
    if (this._maps.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapData) {
      return value;
    }
    return MapData.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapData();
    result._maps = JsonToList(json.maps, Map);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._maps.length > 0) {
      result.maps = ArrayToJson(this._maps, Map);
    }
    return result;
  }
  /**
   * @returns {Map[]}
   */
  get maps() {
    return this._maps;
  }
  addMaps(path, value) {
    return {type: 'ADD', path: path.concat(['maps']), value: value.toJson()};
  }
  setMaps(path, value) {
    return {type: 'SET', path: path.concat(['maps']), value: ArrayToJson(value, Map)};
  }
  setMapsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['maps', key]), value: value.toJson()};
  }
  deleteMaps(path) {
    return {type: 'DELETE', path: path.concat(['maps'])};
  }
  deleteMapsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['maps', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "maps": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapData(this);
              copy._maps = [];        for (let i of value) {
                copy._maps.push(Map.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapData(this);
              copy._maps = copy._maps.concat([Map.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._maps.length === 0) {
                return this;
              }
              const copy = new MapData(this);
              copy._maps = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._maps.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapData(this);
              copy._maps = copy._maps.slice();
              copy._maps[path[1]] = Map.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapData(this);
              copy._maps = copy._maps.slice(0, path[1]).concat(copy._maps.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._maps.length) {
            return this;
          }
          const oldValue = this._maps[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapData(this);
          copy._maps = copy._maps.slice();
          copy._maps[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapData} other
   * @returns {MapData}
   */
  merge(other) {
    const copy = new MapData(this);
    copy._maps = this._maps.concat(other._maps);
    return copy;
  }
}
MapData.default = new MapData();
class MapData_Builder {
  constructor(value) {
    this._value = new MapData(value);
  }
  build() {
    return new MapData(this._value);
  }
  addAllMaps(values) {
    this._value._maps = this._value._maps.concat(values);
    return this;
  }
  addMaps(value) {
    this._value._maps = this._value._maps.concat([value]);
    return this;
  }
  setMaps(index, value) {
    this._value._maps = this._value._maps.concat();
    this._value._maps[index] = value;
    return this;
  }
  clearMaps() {
    this._value._maps = [];
    return this;
  }
}
MapData.Builder = MapData_Builder;
class MapData_WithParent {
  /**
   * @param {MapData} value
   * @param {MapData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMaps() {
    if (!this._selfMaps) {
      this._selfMaps = [];
      for (let i of this._value.maps) {
        this._selfMaps.push(new Map.WithParent(i, null));
      }
    }
    return this._selfMaps;
  }
  get inherentMaps() {
    if (!this._inherentMaps) {
      this._inherentMaps = this._parent ? this._parent.maps : [];
    }
    return this._inherentMaps;
  }
  get maps() {
    if (!this._allMaps) {
      this._allMaps = this._parent ? this._parent.maps.concat(this.selfMaps) : this.selfMaps;
    }
    return this._allMaps;
  }
  update(current, parent) {
    const result = new MapData_WithParent(current, parent);
    if (this._selfMaps) {
      if (this._value.maps === current.maps) {
        result._selfMaps = this._selfMaps;
      } else {
        result._selfMaps = [];
        for (let i = 0; i < current.maps.length; i++) {
          const oldValue = this._value.maps[i];
          if (oldValue) {
            const oldCache = this._selfMaps[i];
            if (oldValue === current.maps[i]) {
              result._selfMaps[i] = oldCache;
            } else {
              result._selfMaps[i] = oldCache.update(current.maps[i], null);
            }
          } else {
            result._selfMaps[i] = new Map.WithParent(current.maps[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapData_WithParent.default = new MapData_WithParent(MapData.default, null);
MapData.WithParent = MapData_WithParent;
class MapData_Descriptor {
  get maps() {
    if (!this._maps) {
      this._maps = {
        name: "maps",
        Name: "Maps",
        number: 1,
        protoType: 11,
        protoName: "maps",
        type: Map,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maps;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.maps,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MapData.descriptor = new MapData_Descriptor();
